import { CSSProperties } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const pageStyle: CSSProperties = {
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '5px',
  };

  const buttonStyle: CSSProperties = {
    padding: '10px 15px',
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    marginTop: '15px',
  };

  return (
    <div style={pageStyle}>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.description')}</p>
      <button onClick={() => navigate('/')} style={buttonStyle}>
        {t('notFound.goToHome')}
      </button>
    </div>
  );
};

export default NotFoundPage;
